<template>
  <div class="sg-order-list">
    <div class="header-tabs">
      <div class="tab" :class="{'active': tabActive===0}" @click="toggleTabActive(0)"><span>全部</span><span class="line"></span></div>
      <div class="tab" :class="{'active': tabActive===1}" @click="toggleTabActive(1)"><span>待付款</span><span class="line"></span></div>
      <div class="tab" :class="{'active': tabActive===2}" @click="toggleTabActive(2)"><span>待收货</span><span class="line"></span></div>
      <div class="tab" :class="{'active': tabActive===3}" @click="toggleTabActive(3)"><span>已完成</span><span class="line"></span></div>
      <div class="tab" :class="{'active': tabActive===4}" @click="toggleTabActive(4)"><span>已取消</span><span class="line"></span></div>
    </div>
    <div class="order-list">
      <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            :error.sync="isError"
            error-text="请求失败，点击重新加载"
            finished-text="没有更多了"
            @load="onLoad"
        >
          <order-item v-for="(item, i) in list" :key="i" :itemData="item" @reloadList="reloadList"></order-item>
        </van-list>
      </van-pull-refresh>
    </div>


  </div>
</template>

<script>
import { sgOrderList } from '@/api/mall/mallOrder'
import OrderItem from './components/orderItem/index'
import { mapGetters } from 'vuex'
export default {
  components: {
    OrderItem,
  },
  data(){
    return {
      tabActive: 0,//默认为全部

      refreshLoading: false,
      loading: false,
      finished: false,
      isError: false,

      page: 1,
      size: 10,
      list: [],
    }
  },
  computed: {
    ...mapGetters([
      'sgOrderType'
    ]),
  },
  watch: {
    sgOrderType:{
      handler(val){
        this.tabActive = val
        // this.sgOrderList()
      },
      immediate: true
    }
  },
  created(){

  },
  methods: {
    toggleTabActive(i){
      this.$store.commit('my/change_sgOrderType', i)
      this.onRefresh()
    },

    onRefresh(){
      this.finished = true;
      this.page = 1;
      window.setTimeout(()=>{
        this.finished = false;
        this.list = [];
        this.refreshLoading = false;
        window.scrollTo(0, 0);
      },100)
    },
    onLoad(){
      let req = {
        page: this.page,
        size: this.size,
      }
      switch (this.sgOrderType) {
        case 0://全部
          // req.orderStatus =
          break;
        case 1://待付款
          req.orderStatus = 'WAIT'
          break;
        case 2://待收货
          req.orderStatus = 'PAID'
          break;
        case 3://已完成
          req.orderStatus = 'FINISH'
          break;
        case 4://已取消
          req.orderStatus = 'CANCELLED'
          break;
      }
      sgOrderList(req).then(res=>{
        // this.list = res.data.items || []
        if(res.code===200){
          if(res.data.items){ //是否有数据
            let arr = res.data.items
            // 如果是第一页需手动制空列表
            if (this.page === 1){
              this.list = [];
            }
            // 把请求到的数据添加到列表
            this.list = this.list.concat(arr)
            this.loading = false

            if(res.data.totalPages===this.page){ // 到达最大页
              this.finished = true;
            }
            this.page++
            console.log('this.finished :  '+this.finished)
          }else {
            this.loading = false;
            this.finished = true;
          }
        }else {
          this.loading = false;
          this.finished = true;
          this.$toast(res.message)
        }
      }).catch(() => {
        this.isError = true;
      })
    },

    //取消订单后书刷新列表
    reloadList(){
      this.onRefresh()
    },

  }
}
</script>

<style lang="less" scoped>
.sg-order-list{
  position: relative;width: 100%;height: 100%;z-index: 0;
  .header-tabs{
    display: flex;justify-content: center;align-items: center;background-color: #fff;
    height: 44px;border-bottom: 1px solid #f5f5f5;position: fixed;top: 0;left: 0;right: 0;
    .tab{
      display: inline-flex;flex: 1;flex-direction: column;justify-content: center;align-items: center;
      height: 100%;font-size: 16px;color: #666;position: relative;z-index: 0;
      .line{position: absolute;width: 80%;height: 2px;bottom: 0;left: 10%;}
      &.active{
        color: #1585f3;
        .line{background-color: #1585f3;}
      }
    }
  }
  .order-list{
    padding-bottom: 20px;background-color: #f5f5f5;
    position: absolute;z-index: 0;top: 44px;bottom: 0;left: 0;right: 0;overflow: auto;
  }
}
</style>